export const colors = {
  bg: '#f6f6f6',
  white: '#ffffff',
  primary: '#155fa2',
  info: '#1e80c0',
  success: '#46833f',
  danger: '#b0153c'
}

export const fontSizes = {
  primary: 20,
  secondary: 16,
  small: 13,
}

export const listItem = {
  container: {
    background: '#ffffff',
    borderBottom: '1px solid #eee',
    padding: '1rem 2rem'
  },
  listHeading: {
    fontSize: fontSizes.large,
    fontWeight: 700,
    marginBottom: '10px'
  },
  verified: {
    fontSize: fontSizes.small,
    color: colors.success
  },
  unverified: {
    fontSize: fontSizes.small,
    fontStyle: 'italic',
    color: colors.danger
  },
  btnLink: {
    border: 0,
    background:'none',
    padding:0,
    margin:0,
    letterSpacing: '0.07em',
    textTransform: 'uppercase',
    fontSize: fontSizes.small
  }
}


// WEBPACK FOOTER //
// ./src/app/utils/style.js